<template>
  <v-stepper v-model="stepper">
    <v-stepper-header>
      <v-stepper-step color="#0B4598" :complete="stepper > 1" step="1">
        Member Search
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step color="#0B4598" :complete="stepper > 2" step="2">
        Dispute Search Data
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step color="#0B4598" step="3">
        Dispute analysis
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <getLocationHygienist
          @error="loader = false"
          @loading="loader = true"
          @next="checkDataForDispute"
        />
      </v-stepper-content>

      <v-stepper-content step="2">
        <selectLocationHygienist @back="stepper -= 1" @next="PushStep3" />
      </v-stepper-content>

      <v-stepper-content step="3">
        <resolveDispute @next="newSearch" />
      </v-stepper-content>
    </v-stepper-items>
    <v-dialog v-model="loader" persistent width="500">
      <v-card dark style="background-color: #0B4598;">
        <v-card-text class="text-center text-h6">
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-stepper>
</template>

<script>
import getLocationHygienist from "@/components/Disputes/getLocationHygienist";
import selectLocationHygienist from "@/components/Disputes/selectLocationHygienist";
import resolveDispute from "@/components/Disputes/resolveDispute";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "Dispute",
  components: {
    getLocationHygienist,
    selectLocationHygienist,
    resolveDispute
  },
  data() {
    return {
      stepper: 1,
      loader: false
    };
  },
  computed: {
    ...mapState(["HygienistForDispute", "LocationForDispute"])
  },
  methods: {
    ...mapActions(["getCommentsForDispute"]),
    ...mapMutations(["modify"]),
    async PushStep3({ pickedHygienist, pickedLocation }) {
      this.loader = true;
      await this.getCommentsForDispute({
        hygienist: this.HygienistForDispute[0],
        location: this.LocationForDispute[0]
      });
      this.stepper = 3;

      this.loader = false;
    },
    async checkDataForDispute() {
      if (
        this.HygienistForDispute.length > 1 ||
        this.LocationForDispute.length > 1
      ) {
        this.stepper = 2;
        this.loader = false;
      } else {
        this.loader = true;
        try {
          await this.getCommentsForDispute({
            hygienist: this.HygienistForDispute[0],
            location: this.LocationForDispute[0]
          });
          setTimeout(() => {
            this.stepper = 3;
            this.loader = false;
          }, 1500);
        } catch (e) {
          this.loader = false;
        }
      }
    },
    newSearch() {
      this.modify({ property: "HygienistForDispute", value: [] });
      this.modify({ property: "LocationForDispute", value: [] });
      this.modify({ property: "HygienistComments", value: [] });
      this.modify({ property: "LocationComments", value: [] });
      this.stepper = 1;
    }
  }
};
</script>

<style scoped></style>
